<form [formGroup]="form" class="hero-disposition-container">
  <mat-form-field>
    <mat-label>Behavior Code</mat-label>
    <input type="text" matInput formControlName="behaviorCodeId" [matAutocomplete]="auto">
    <mat-icon matSuffix class="icon" *ngIf="!form.get('behaviorCodeId').value">arrow_drop_down</mat-icon>
    <button
      matSuffix
      class="icon"
      *ngIf="form.get('behaviorCodeId').value"
      mat-icon-button
      aria-label="Clear"
      (click)="onClear('behaviorCodeId')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeOptions')" showPanel="true">
      <mat-option *ngFor="let option of filteredBehaviorCodeOptions | async" [value]="option.value">
        {{option.display}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field *ngIf="behaviorCodeReactionOptions && behaviorCodeReactionOptions.length" class="full-width-input">
    <mat-label>Reaction</mat-label>
    <input type="text" matInput formControlName="behaviorCodeReactionId" [matAutocomplete]="autoReactions">
    <mat-icon matSuffix class="icon" *ngIf="!form.get('behaviorCodeReactionId').value">arrow_drop_down</mat-icon>
    <button
      matSuffix
      class="icon"
      *ngIf="form.get('behaviorCodeReactionId').value"
      mat-icon-button
      aria-label="Clear"
      (click)="onClear('behaviorCodeReactionId')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoReactions="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeReactionOptions')" showPanel="true">
      <mat-option *ngFor="let option of filteredBehaviorReactionOptions | async" [value]="option.value">
        {{option.display}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field *ngIf="heroDisposition.behaviorCodeEntry">
    <mat-label>Action Date</mat-label>
    <input disabled="true" matInput placeholder="Grade" [value]="heroDisposition?.behaviorCodeEntry.name || 'no date'" />
  </mat-form-field>
</form>
